import { MapContentLayer } from '../MapContentLayer';
import { CircleLayerSpecification, LayerSpecification } from 'maplibre-gl';
import { MapContentSource } from '../MapContentSource';
import { TrackStyles } from '../../../../../configuration/model/TrackStyles';

export class ImageCirclePaddingLayer extends MapContentLayer {

  constructor(
    source: MapContentSource,
    private trackStyles: TrackStyles,
  ) {
    super('image-circle-padding-layer', source);
  }

  toLayerSpecification(): LayerSpecification {
    return {
      id: this.layerId,
      type: 'circle',
      source: this.sourceRef.sourceId,
      paint: {
        'circle-color': '#ff0000',
        'circle-radius': 15,
        'circle-stroke-width': 2,
        'circle-opacity': 0,
        'circle-stroke-opacity': 0,
      },
      minzoom: 16,
    } as CircleLayerSpecification;
  }

}
